<template>
  <div class="appStore">
    <div class="title">APP</div>
    <div class="subtitle">
      <br />Baixe o nosso aplicativo e registre seu login para resolver esta
      pendência.
    </div>
    <br />

    <div class="info">
      - Será necessário conceceder permissão de geolocalização.
      <br />- Sua posição geográfica só será registrada quando tiver associado a
      um job e dentro da janela de deslocamento monitorado (01 hora antes do
      atendimento). <br />- Dentro da janela de deslocamento monitorado, o
      aplicativo providenciará automaticamente seu registro de deslocamento e
      checkin. <br />- Confira detalhes e orientações do job antes de iniciar
      deslocamento.
    </div>
    <div class="column align-center box">
      <a
        :href="user.url_loja_android || 'https://play.google.com/store/apps'"
        target="_blank"
      >
        <img src="../../assets/img/gp.png" width="200" />
        <div class="sub">
          <em>Baixe o nosso APP na Google Play</em>
        </div>
        <Button layout="green-go" type="button">BAIXAR</Button>
      </a>
    </div>
    <br />
    <br />
    <br />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Button from "@/components/Button.vue";
export default {
  components: { Button },
  props: { modal: Object },
  data() {
    return {};
  },
  methods: {
  
  }, computed: {
    ...mapGetters("user", ["user"])
  }
};

</script>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;
.appStore {
  color: $gray-6;
  max-width: 700px;
  padding: 30px;

  .subtitle {
    color: #666;
  }
  .info {
    font-size: 14px;
    color: $gray-2;
    padding: 10px;
    background: #eee;
    border-radius: 5px;
    margin-bottom: 50px;
    line-height: 1.7rem;
  }
  .title {
    font-size: 22px;
    font-weight: 600;
  }

  .button-green-go {
    margin-top: 20px;
    width: 200px;
  }
  strong {
    font-weight: 500;
    color: $gray-1;
  }
  .box {
    margin: 0 auto;
    box-shadow: $shadow;
    width: 225px;
    padding: 1.5rem 1rem;
    border-radius: 5px;
  }
  .sub {
    margin-top: 25px;
    color: $gray-1;
    text-align: center;
  
    em {
      font-size: 11px;
      margin-top: 18px;
    }
  }

}
</style>